import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SenhaService } from 'src/app/services';
import { confirmarSenhaValidator } from 'src/app/validators';

@Component({
  selector: 'app-concluir-redefinir-senha',
  templateUrl: './concluir-redefinir-senha.component.html',
  styleUrls: ['./concluir-redefinir-senha.component.scss']
})
export class ConcluirRedefinirSenhaComponent implements OnInit, OnDestroy {
  subscription$ = new Subscription();
  redefinirSenhaForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private senhaService: SenhaService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  redefinirSenha() {
    this.subscription$.add(
      this.senhaService.putSenha(this.redefinirSenhaForm.value).subscribe({
        next: () => {
          this.router.navigate(['/login']);
        }
      })
    );
  }

  ngOnInit(): void {
    const { token } = this.activatedRoute.snapshot.queryParams;
    this.redefinirSenhaForm = this.fb.group(
      {
        token: [token, [Validators.required]],
        senha: [
          '',
          [
            Validators.required,
            Validators.pattern(
              /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&#]).{8,}/
            )
          ]
        ],
        confirmarSenha: ['', [Validators.required]]
      },
      { validators: confirmarSenhaValidator('senha', 'confirmarSenha') }
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
